import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MobileExperience = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('mobile-experience-section');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Mobile Sticky CTA Bar - Only visible on mobile */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-brand border-t border-border p-4">
        <div className="flex space-x-3">
          <Link to="/about-ecosystem" className="flex-1">
            <Button
              variant="outline"
              size="sm"
              iconName="Eye"
              iconPosition="left"
              className="w-full touch-target"
            >
              View Work
            </Button>
          </Link>
          <Link to="/contact-consultation" className="flex-1">
            <Button
              variant="default"
              size="sm"
              iconName="MessageCircle"
              iconPosition="left"
              className="cta-primary w-full touch-target"
            >
              Get Started
            </Button>
          </Link>
        </div>
      </div>

      {/* Mobile-Optimized Content Section */}
      <section id="mobile-experience-section" className="md:hidden py-16 bg-muted/30">
        <div className="container mx-auto px-4">
          <div className={`text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {/* Mobile Hero Summary */}
            <div className="bg-card border border-border rounded-brand shadow-brand-card p-6 mb-8">
              <div className="w-16 h-16 bg-brand-gradient rounded-brand mx-auto mb-4 flex items-center justify-center">
                <Icon name="Smartphone" size={24} className="text-white" />
              </div>
              
              <h2 className="text-2xl font-bold mb-4">
                Mobile-First <span className="text-gradient-brand">Development</span>
              </h2>
              
              <p className="text-text-secondary mb-6">
                We create responsive, touch-friendly experiences that work seamlessly 
                across all devices and screen sizes.
              </p>

              {/* Mobile Stats */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="text-center">
                  <div className="text-2xl font-bold text-secondary mb-1">95%</div>
                  <div className="text-xs text-text-secondary">Mobile Performance</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-success mb-1">&lt;2s</div>
                  <div className="text-xs text-text-secondary">Load Time</div>
                </div>
              </div>

              {/* Touch-Friendly Features */}
              <div className="space-y-3">
                <div className="flex items-center space-x-3 text-sm">
                  <Icon name="Smartphone" size={16} className="text-secondary" />
                  <span>Touch-optimized interfaces</span>
                </div>
                <div className="flex items-center space-x-3 text-sm">
                  <Icon name="Zap" size={16} className="text-warning" />
                  <span>Lightning-fast performance</span>
                </div>
                <div className="flex items-center space-x-3 text-sm">
                  <Icon name="Shield" size={16} className="text-success" />
                  <span>Secure mobile architecture</span>
                </div>
              </div>
            </div>

            {/* Quick Contact Card */}
            <div className="bg-card border border-border rounded-brand shadow-brand-card p-6">
              <h3 className="text-lg font-bold mb-4">Ready to Transform Your Business?</h3>
              
              <div className="space-y-4 mb-6">
                <div className="flex items-center justify-center space-x-2 text-sm text-text-secondary">
                  <Icon name="Clock" size={16} />
                  <span>Free 30-minute consultation</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-sm text-text-secondary">
                  <Icon name="Award" size={16} />
                  <span>No commitment required</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-sm text-text-secondary">
                  <Icon name="Users" size={16} />
                  <span>Expert team ready to help</span>
                </div>
              </div>

              <div className="space-y-3">
                <Link to="/contact-consultation">
                  <Button
                    variant="default"
                    size="lg"
                    iconName="Calendar"
                    iconPosition="left"
                    className="cta-primary w-full touch-target"
                  >
                    Schedule Free Consultation
                  </Button>
                </Link>
                
                <div className="flex space-x-3">
                  <a href="tel:+1-555-0123" className="flex-1">
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="Phone"
                      iconPosition="left"
                      className="w-full touch-target"
                    >
                      Call Now
                    </Button>
                  </a>
                  <a href="mailto:sales@manicasolutions.com" className="flex-1">
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="Mail"
                      iconPosition="left"
                      className="w-full touch-target"
                    >
                      Email Us
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileExperience;